<section class="docs-page">
  <div class="docs-header">
    <div class="docs-page__nav">
      <div class="docs-page__toggles">
        <button
          [attr.aria-pressed]="activeSection === 'api-docs'"
          [class.docs-page__toggle--active]="activeSection === 'api-docs'"
          mat-stroked-button
          [color]="activeSection === 'api-docs' ? 'primary' : undefined"
          (click)="showApiDocsSection()"
        >
          API Docs
        </button>
        <button
          [attr.aria-pressed]="activeSection === 'api-reference'"
          [class.docs-page__toggle--active]="activeSection === 'api-reference'"
          mat-stroked-button
          [color]="activeSection === 'api-reference' ? 'primary' : undefined"
          (click)="showApiReferenceSection()"
        >
          API Reference
        </button>
        <button
          *ngFor="let assistantDocs of availableAssistantDocs"
          [attr.aria-pressed]="isAssistantDocsSelected(assistantDocs.integrationId)"
          [class.docs-page__toggle--active]="isAssistantDocsSelected(assistantDocs.integrationId)"
          mat-stroked-button
          [color]="isAssistantDocsSelected(assistantDocs.integrationId) ? 'primary' : undefined"
          (click)="showAssistantDocsSection(assistantDocs.integrationId)"
        >
          {{ assistantDocs.label }}
        </button>
      </div>

      <div class="docs-page__downloads">
        <button
          mat-stroked-button
          color="primary"
          (click)="downloadOpenApiJson()"
        >
          Download OpenAPI JSON
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="downloadOpenApiYaml()"
        >
          Download OpenAPI YAML
        </button>
        <button
          mat-stroked-button
          color="primary"
          (click)="downloadRaml()"
        >
          Download RAML
        </button>
      </div>
    </div>
  </div>

  <div class="docs-page__status" *ngIf="loading">Loading API documentation…</div>
  <div class="docs-page__status docs-page__status--error" *ngIf="!loading && error">
    {{ error }}
  </div>

  <section *ngIf="!loading && !error && activeSection === 'api-docs'" class="docs-page__guide">
    <article class="docs-guide__section" *ngFor="let section of guideSections">
      <h2>{{ section.title }}</h2>
      <p>{{ section.content }}</p>
      <ul *ngIf="section.bullets?.length">
        <li *ngFor="let bullet of section.bullets">{{ bullet }}</li>
      </ul>
      <div *ngIf="section.referenceLinks?.length" class="docs-guide__links">
        <span>Reference links:</span>
        <button mat-button *ngFor="let link of section.referenceLinks" (click)="showApiReferenceSection()">
          {{ link.label }}
        </button>
      </div>
    </article>
  </section>

  <section *ngIf="!loading && !error && activeSection === 'assistant-docs' && selectedAssistantDocs as assistantDocs">
    <div class="docs-assistant-layout">
      <div class="docs-assistant-layout__left">
        <article class="docs-guide__section" *ngFor="let section of assistantDocs.sections">
          <h2>{{ section.title }}</h2>
          <p>{{ section.content }}</p>
          <ul *ngIf="section.bullets?.length">
            <li *ngFor="let bullet of section.bullets">{{ bullet }}</li>
          </ul>
        </article>
      </div>

      <div class="docs-assistant-layout__right">
        <article class="docs-guide__section docs-embed-generator">
          <h2>{{ assistantDocs.integrationName }} Embed Code Generator</h2>

          <div class="docs-embed-generator__form">
            <label>
              Environment
              <select [(ngModel)]="assistantEmbedEnvironment">
                <option value="production">Production</option>
                <option value="staging">Staging</option>
              </select>
            </label>
            <details class="docs-embed-generator__options">
              <summary>Optional Settings</summary>
              <label>
                Custom HTML URL
                <input
                  type="text"
                  placeholder="https://example.com/widget.html"
                  [(ngModel)]="assistantEmbedCustomHtmlUrl"
                />
              </label>
              <label>
                Custom CSS URL
                <input
                  type="text"
                  placeholder="https://example.com/widget.css"
                  [(ngModel)]="assistantEmbedCustomCssUrl"
                />
              </label>
            </details>
            <button mat-stroked-button color="primary" (click)="generateAssistantEmbedCode()">
              Generate Embed Code
            </button>
          </div>

          <div class="docs-page__status docs-page__status--error" *ngIf="assistantEmbedError">{{ assistantEmbedError }}</div>

          <div *ngIf="assistantEmbedGenerated" class="docs-embed-generator__output">
            <h3>Complete HTML Code</h3>
            <div class="docs-embed-generator__code">
              <button mat-stroked-button (click)="copyAssistantEmbedCode('html')">
                {{ copiedCodeKind === 'html' ? 'Copied' : 'Copy' }}
              </button>
              <pre>{{ assistantEmbedHtmlCode }}</pre>
            </div>

            <h3>Script Only</h3>
            <div class="docs-embed-generator__code">
              <button mat-stroked-button (click)="copyAssistantEmbedCode('script')">
                {{ copiedCodeKind === 'script' ? 'Copied' : 'Copy' }}
              </button>
              <pre>{{ assistantEmbedScriptCode }}</pre>
            </div>

            <h3>Mobile Testing URL</h3>
            <div class="docs-embed-generator__mobile">
              <button mat-stroked-button (click)="copyAssistantEmbedCode('mobile')">
                {{ copiedCodeKind === 'mobile' ? 'Copied' : 'Copy' }}
              </button>
              <a [href]="assistantEmbedMobileUrl" target="_blank" rel="noopener noreferrer">{{ assistantEmbedMobileUrl }}</a>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>

  <section *ngIf="!loading && !error && activeSection === 'api-reference'">
    <div class="docs-reference">
      <aside class="docs-reference__list">
        <article class="docs-reference-group" *ngFor="let group of groupedOperations">
          <h2>{{ group.tag }}</h2>
          <button
            mat-button
            class="docs-reference-item"
            [class.docs-reference-item--selected]="isSelected(operation)"
            *ngFor="let operation of group.operations"
            (click)="selectOperation(operation)"
          >
            <div class="docs-reference-item__top">
              <span class="docs-reference-item__method"><code>{{ operation.method }}</code></span>
              <span class="docs-reference-item__path"><code>{{ operation.path }}</code></span>
            </div>
            <div class="docs-reference-item__summary">{{
              operation.summary || operation.details.description
            }}</div>
          </button>
        </article>
      </aside>

      <section class="docs-operation-detail" *ngIf="selectedOperation as operation">
        <div class="docs-operation-detail__header">
          <code>{{ operation.method }}</code>
          <code>{{ operation.path }}</code>
        </div>
        <div *ngIf="operation.details.summary">{{ operation.details.summary }}</div>
        <div *ngIf="operation.details.description">{{ operation.details.description }}</div>
        <div><strong>Parameters:</strong> {{ parameterSummary(operation) }}</div>
        <div><strong>Request body:</strong> {{ requestBodySummary(operation) }}</div>
        <div *ngIf="hasRequestExample(operation)">
          <strong>Request example:</strong>
          <div *ngFor="let ex of requestExamples(operation)">
            <div class="docs-operation-detail__example-label">{{ ex.label }}</div>
            <pre>{{ ex.json }}</pre>
          </div>
        </div>
        <div><strong>Response codes:</strong> {{ responseCodeSummary(operation) }}</div>
        <div><strong>Response headers:</strong> {{ responseHeaderSummary(operation) }}</div>
        <div *ngIf="hasResponseExample(operation)">
          <strong>Response example:</strong>
          <pre>{{ responseExample(operation) }}</pre>
        </div>
        <div><strong>Security:</strong> {{ securitySummary(operation) }}</div>
      </section>
    </div>
  </section>
</section>
